import React from "react";
import { Input } from "@pd/pd-ui-kit";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import FormDateField from "~/pages/BaseStaff/EmployeeProfileEditor/EmployeeProfileForm/sections/FormDateField";
import FormField from "~/pages/BaseStaff/EmployeeProfileEditor/EmployeeProfileForm/sections/FormField";
import { TFileInfo } from "~/pages/BaseStaff/EmployeeProfileEditor/EmployeeProfileForm/model/types";
import { FileFieldController } from "~/shared/ui/Fields/FileField";

import { IDealerRowProps, TDealerErrors } from "./types";

import s from "~/pages/BaseStaff/EmployeeProfileEditor/EmployeeProfileForm/EmployeeProfileForm.less";

interface IAppointmentFieldsRowProps extends IDealerRowProps {
  dealerErrors?: TDealerErrors;
  disabled?: boolean;
  positionOrderRequired: boolean;
  positionOrderFile?: TFileInfo | null;
}

const AppointmentFieldsRow = ({
  control,
  dealerPrefix,
  dealerErrors,
  disabled,
  positionOrderRequired,
  positionOrderFile,
}: IAppointmentFieldsRowProps) => {
  const { t } = useTranslation();

  return (
    <div className={s.grid4}>
      <FormDateField
        name={`${dealerPrefix}.startDate`}
        control={control}
        label={t("employee.startDate")}
        disabled={disabled}
        error={dealerErrors?.startDate?.message}
        required
      />

      <FormField label={t("employee.startOrderNumber")} required>
        <Controller
          name={`${dealerPrefix}.startOrderNumber`}
          control={control}
          render={({ onChange, value, onBlur }) => (
            <Input
              value={value}
              onChange={(e) => onChange(e.target.value)}
              onBlur={onBlur}
              disabled={disabled}
              status={dealerErrors?.startOrderNumber ? "error" : undefined}
              errorText={dealerErrors?.startOrderNumber?.message}
            />
          )}
        />
      </FormField>

      <FormField label={t("employee.hired")}>
        <Controller
          name={`${dealerPrefix}.hired`}
          control={control}
          render={({ value }) => <Input value={value || ""} disabled />}
        />
      </FormField>

      <FormField label={t("employee.order")} required={positionOrderRequired}>
        <FileFieldController
          name={`${dealerPrefix}.positionOrderId`}
          control={control}
          accept=".png,.jpg,.jpeg,.doc,.pdf,.docx"
          maxSizeMb={5}
          disabled={disabled}
          error={dealerErrors?.positionOrderId?.message}
          initialFile={
            positionOrderFile
              ? {
                  id: positionOrderFile.id,
                  name: positionOrderFile.name || t("employee.order"),
                  link: positionOrderFile.link || "",
                }
              : null
          }
        />
      </FormField>
    </div>
  );
};

export default AppointmentFieldsRow;
